import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { api } from '@/api/client'

export type Quest = {
  id: string
  title: string
  description: string
  target: number
  progress: number
  unit: string
  reward_xp: number
  completed_at: string | null
}

export type QuestWeek = {
  week_start: string
  ends_at: string
  timezone: string
  quests: Quest[]
  earned_xp: number
}

const KEY = ['character', 'quests'] as const

export function useWeeklyQuests() {
  return useQuery({ queryKey: KEY, queryFn: () => api.get<QuestWeek>('/character/quests'), refetchInterval: 60_000 })
}

/** POST отдельно от чтения: сервер фиксирует неделю и единожды выдаёт заработанный бонус. */
export function useRefreshQuests() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: () => api.post<QuestWeek>('/character/quests/refresh', {}),
    onSuccess: (data) => {
      if (!Array.isArray(data?.quests)) return
      client.setQueryData(KEY, data)
      void client.invalidateQueries({ queryKey: ['character'], exact: true })
      void client.invalidateQueries({ queryKey: ['character', 'session'] })
      void client.invalidateQueries({ queryKey: ['character', 'achievements'] })
    },
  })
}

export function useSyncQuests(scope: string) {
  const refresh = useRefreshQuests()
  const { mutate } = refresh
  useEffect(() => { mutate() }, [mutate, scope])
  return refresh
}
